import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle_plus",
  "use": "icon-circle_plus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" id=\"icon-circle_plus\">\n  <circle cx=\"12.5\" cy=\"12.5\" r=\"12.5\" />\n  <path fill=\"#ffffff\" d=\"M633,2331h9v3h-9v-3Zm3-3h3v9h-3v-9Z\" transform=\"translate(-625 -2320)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol